
module cr.entity
{

    class entityTestController {

        constructor(private $scope,private treeNode:ITreeNode) {
            console.log("new instance of test");
            $scope.test=()=>{
                console.log("test: "+treeNode.id);
            }

       }
    }

    // Module registrations.
    entityModule.controller('entityTestController', ['$scope','treeNode', entityTestController]);

}
